import React from 'react';
import {Typography} from '@mui/material';
import BaseModal from '../../../utils/BaseModal';

type Props = {
  open: boolean;
  jobName: string | null;
  onClose: () => void;
  onConfirm: () => void;
};

const JobConfirmModal: React.FC<Props> = ({open, jobName, onClose, onConfirm}) => {
  return (
      <BaseModal
          open={open}
          title="Batch Job starten"
          onAbort={onClose}
          onSubmit={onConfirm}
          submitText="Starten"
          abortText="Abbrechen"
          maxWidth="xs"
      >
        <Typography variant="body1">
          Möchtest du den Job <span className="font-bold text-indigo-500">{jobName}</span> wirklich manuell starten?
        </Typography>
      </BaseModal>
  );
};

export default JobConfirmModal;